(function (angular) {
    angular.module('bizPartEngage').directive('bizOpenLoginBtns', bizOpenLoginBtnsDirective);

    bizOpenLoginBtnsDirective.$inject = ["bizCore", "$filter", "loginService"];

    function bizOpenLoginBtnsDirective(bizCore, $filter, loginService) {
        var directive = {
            restrict: "E",
            scope: {
                openIdOnly: "@?"
            },
            templateUrl: bizCore.getView('core.directives.openidloginbtns', "FrontEnd/Core/Directives/Views/OpenIdLoginBtns.html"),
            bindToController: true,
            controller: bizOpenLoginBtnsController,
            controllerAs: "vm"
        };

        function bizOpenLoginBtnsController() {
            var vm = this;

            
            vm.GoToOpenIdLogin = GoToOpenIdLogin;            

            function GoToOpenIdLogin(provider) {
                window.location.href = $filter('siteroot')('~/OpenIdLogin/' + provider.Id);
            }

            vm.$onInit = function () {                
                loginService.GetActiveOpenIdProviders().then(GetActiveOpenIdProvidersSuccess);

                function GetActiveOpenIdProvidersSuccess(response) {
                    vm.Providers = response.data;
                }                
            }
        }

        return directive;
    }
})(window.angular);